// extracted by mini-css-extract-plugin
export default {"container":"CPNWReviewerPage_container__lu3su","loading":"CPNWReviewerPage_loading__KtIhP"};